module.exports = __webpack_public_path__ + "static/media/transfer.2fa5e3c7.svg";